/** Normalize to ASCII digits only (max 10). */
export function sanitizeNationalId(value: string): string {
  return String(value ?? '')
    .replace(/[۰-۹]/g, (d) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)))
    .replace(/[٠-٩]/g, (d) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(d)))
    .replace(/\D/g, '')
    .slice(0, 10)
}

/** Iranian national ID (کد ملی) checksum — 10 digits, not all equal. */
export function isValidNationalId(value: string): boolean {
  const id = sanitizeNationalId(value)
  if (!/^\d{10}$/.test(id)) return false
  if (/^(\d)\1{9}$/.test(id)) return false
  let sum = 0
  for (let i = 0; i < 9; i++) {
    sum += Number(id[i]) * (10 - i)
  }
  const rem = sum % 11
  const check = rem < 2 ? rem : 11 - rem
  return check === Number(id[9])
}
